<template>
  <v-dialog
      v-model="visible"
      persistent
      width="auto"
      overlay-opacity="0.62"
  >
    <v-card width="600">
      <div class="px-6 pt-4 d-flex align-items-center">
        <div class="pt-2 font-14 font-weight-medium">
          Local de recebimento
        </div>

        <v-spacer />

        <v-btn icon @click="handleClose()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-form>
        <div class="px-6 pt-4">
          <!-- FILIAL -->
          <v-select
              v-model="formData.filial"
              :items="dataSet"
              small-chips
              label="Filial *"
              outlined
              dense
              item-value="idfilial"
              :item-text="item => item.razao_social || item.nome_fantasia"
              :error-messages="validate.filial"
          />

          <!-- ENDEREÇO -->
          <v-text-field
              v-model="formData.endereco"
              label="Endereço *"
              outlined
              dense
              :error-messages="validate.endereco"
          />

          <!-- JANELA -->
          <p class="mb-3 font-weight-medium">Janela de recebimento *</p>

          <p class="mb-3 font-weight-medium">Horários</p>
          <div class="d-flex">
            <v-text-field
                v-model="formData.inicio"
                placeholder="08:00"
                append-icon="mdi-clock-outline"
                v-mask="'##:##'"
                outlined
                dense
                :error-messages="validate.inicio"
            />

            <div class="divider">até</div>

            <v-text-field
                v-model="formData.fim"
                placeholder="10:00"
                append-icon="mdi-clock-outline"
                v-mask="'##:##'"
                outlined
                dense
                :error-messages="validate.fim"
            />
          </div>

          <!-- DIAS -->
          <p class="mb-3 font-weight-medium">Dias *</p>

          <div>
            <div class="d-flex">
              <v-checkbox v-model="formData.dias" label="Segunda" value="segunda" style="width: 120px" />
              <v-checkbox v-model="formData.dias" label="Terça" value="terca" style="width: 120px" />
              <v-checkbox v-model="formData.dias" label="Quarta" value="quarta" style="width: 120px" />
              <v-checkbox v-model="formData.dias" label="Quinta" value="quinta" style="width: 120px" />
            </div>
            <div class="d-flex">
              <v-checkbox v-model="formData.dias" label="Sexta" value="sexta" style="width: 120px" />
              <v-checkbox v-model="formData.dias" label="Sábado" value="sabado" style="width: 120px" />
              <v-checkbox v-model="formData.dias" label="Domingo" value="domingo" style="width: 120px" />
            </div>

            <div style="color: red; font-size: small; font-weight: normal" v-if="validate.dias">
              {{ validate.dias }}
            </div>
          </div>

          <!-- OBSERVAÇÃO -->
          <p class="my-3 font-weight-medium">Observações</p>
          <v-textarea
              v-model="formData.observacao"
              outlined
              dense
              placeholder="Escreva aqui..."
              :counter="observacaoMaxLen"
              :error-messages="validate.observacao"
              auto-grow
              rows="3"
              :maxlength="observacaoMaxLen"
          />
        </div>
      </v-form>

      <v-card-title class="d-flex justify-end pb-6">
        <v-btn class="mx-2 wc-btn-actions" text @click="handleClose()">
          Cancelar
        </v-btn>

        <v-btn class="wc-btn-actions" color="primary" @click="onSaveClick">
          Salvar local
        </v-btn>
      </v-card-title>
    </v-card>
  </v-dialog>
</template>

<script setup>
import useLocalRecebimentoForm from "@/components/webcotacao/composables/useLocaisRecebimentoForm";

const emit = defineEmits(["save"]);

const props = defineProps({
  visible: Boolean,
  handleClose: Function,
  editData: { type: Object, default: () => null },
});

const { dataSet, formData, validate, onSaveClick, observacaoMaxLen } =
    useLocalRecebimentoForm(props, emit);
</script>

<style>
.divider {
  width: 25px;
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 10px;
}


</style>
